import { render } from "./UserSideBar.vue?vue&type=template&id=e6037eec&scoped=true"
import script from "./UserSideBar.vue?vue&type=script&lang=js"
export * from "./UserSideBar.vue?vue&type=script&lang=js"

import "./UserSideBar.vue?vue&type=style&index=0&id=e6037eec&scoped=true&lang=css"

import exportComponent from "C:\\Users\\HP\\Desktop\\Vuejsproject\\final\\yajobici-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6037eec"]])

export default __exports__